<template>
  <div>
    <custom-callout
      :border-color="'gray'"
      class-main="mt-3 rounded"
      :has-toggle="false"
      :opened="false"
    >
      <div class="row py-2 mr-md-0 align-items-center mobile-only">
        <div class="col-12 col-md-1 text-center mr-n5">
          <div class="col-12 mb-4">
            <div
              class="
                d-flex
                flex-column
                font-weight-bold
                color-black
                mt-n5
                ml-n4
                mt-sm-n5
                ml-sm-n4
              "
            >
              <div class="dot text-center color-white">
                <i class="fa fa-phone fa-flip-horizontal" />
              </div>
            </div>
          </div>
          <div class="col-12" />
        </div>
        <div class="col col-sm col-12 mt-3 mt-md-0">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">
              {{ title }}
            </div>
            <div class="color-black font-16">
              {{ fullName }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Celular:</div>
            <div class="color-black font-16">
              {{ data.cellPhone.trim() | phone }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">Municipio de Residencia:</div>
            <div class="color-black font-16">
              {{ data.municipalityDescription | empty }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Hogar:</div>
            <div class="color-black font-16">
              {{ data.homePhone.trim() | phone }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12 ">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">Departamento:</div>
            <div class="color-black font-16">
              {{ data.department | empty }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Trabajo:</div>
            <div class="color-black font-16">
              {{ data.workPhone.trim() | phone }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12 ">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">Posición:</div>
            <div class="color-black font-16">
              {{ data.position | empty }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Fax:</div>
            <div class="color-black font-16">
              {{ data.fax.trim() | phone }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12 ">
          <div class="col-12 mb-4">
            <div class="color-gray-6 font-14">Correo Electrónico:</div>
            <div class="color-black font-16">
              {{ data.email | empty }}
            </div>
          </div>
          <div class="col-12">
            <div class="color-gray-6 font-14">Ext:</div>
            <div class="color-black font-16">
              {{ data.ext.trim() | phone }}
            </div>
          </div>
        </div>
        <div class="col col-sm col-12">
          <div class="mb-5 d-flex justify-content-end">
            <drop-down :items="actionItems" />
          </div>
        </div>
      </div>
      <div v-if="data.userId" class="row py-2 mr-md-0 resultProvider">
        <div class="col col-sm col-12">
          <result-provider-contact :contact="data" />
        </div>
      </div>
    </custom-callout>
    <slot :contact="data" />
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import ResultProviderContact from './ResultProviderContact.vue';

export default {
  name: 'ContactResultRow',
  components: {
    CustomCallout,
    DropDown,
    ResultProviderContact,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
  computed: {
    fullName() {
      return `${this.data.nameFirst || ''} ${this.data.nameInitial || ''} ${this
        .data.nameLastPaternal || ''} ${this.data.nameLastMaternal ||
        ''}`.trim();
    },
    title() {
      return this.data.isPrimaryContactFlag
        ? 'Contacto Primario:'
        : 'Contacto Secundario:';
    },
    hasSyncContactInfoPermission() {
      return this.userHasPermissions('rempro.async.user.contact.info.btn');
    },
    actionItems() {
      return [
        {
          label: 'Editar',
          icon: 'fas fa-edit color-green',
          border: this.data.isPrimaryContactFlag ? '' : 'bottom',
          click: () => this.$emit('on-edit-contact'),
        },
        {
          label: 'Asociar usuario existente',
          icon: 'fas fa-sync color-green',
          border: this.data.isPrimaryContactFlag ? '' : 'bottom',
          visible: this.hasSyncContactInfoPermission && !this.data.userId,
          click: () => this.$emit('on-asoc-user-info'),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red',
          visible: !this.data.isPrimaryContactFlag,
          click: () => this.$emit('on-delete-contact'),
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.dot {
  background-color: map-get($colors, 'orange');
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
}

.mr-n6 {
  margin: 0 -6rem;
}

.resultProvider {
  background-color: white;
  margin-bottom: 10px !important;
}

@media screen and (max-width: 768px) {
  .mobile-only {
    display: block;
  }
  .mt-sm-n5 {
    margin-top: 0 !important;
  }
  .ml-sm-n4 {
    margin-left: 0 !important;
  }
}
</style>
